import React, { CSSProperties } from "react";
import "./OrderTypeCell.css";

interface OrderTypeCellProps {
  type: "New" | "Existing" | string;
}

const OrderTypeCell: React.FC<OrderTypeCellProps> = ({ type }) => {
  const getTypeStyles = (): CSSProperties => {
    switch (type?.toLowerCase()) {
      case "new":
        return {
          backgroundColor: "#e2ecf7",
          color: "#6193d4",
        };
      case "existing":
        return {
          backgroundColor: "#e0f2d8",
          color: "#9fd77f",
        };
      default:
        return {
          backgroundColor: "#F1F1F1",
          color: "#777",
        };
    }
  };

  return (
    <div className="order-type-pill" style={getTypeStyles()}>
      {type ? type.charAt(0).toUpperCase() + type.slice(1).toLowerCase() : ""}
    </div>
  );
};

export default OrderTypeCell;
